import { cardholderIdActions } from '../common/validator/cardholder-id-handle';
import cardProvidersMarkup from './card-providers-markup';
import { getCustomerUuid } from '../common-helpers/getCustomerUuid';

export const cardholderIdAllowedLocales = ['pt_BR', 'es_AR'];

export const getStyleConfig = () => {
  return {
    /* Forwarded to iframes */
    stylesheets: [
      {
        href: 'https://fonts.googleapis.com/css?family=Plus Jakarta Sans:300,400,500,600,700&display=swap',
      },
      {
        href: backEndVars.primerStylesheet,
      },
    ],

    /* Unified across all inputs: inside and outside iframes */
    input: {
      base: {
        fontFamily: 'Plus Jakarta Sans',
      },
    },
  };
};

export const validateNameField = input => {
  const pattern = /\d/;

  if (pattern.test(input.value)) {
    input.classList.remove('valid');
    input.classList.add('error', 'dirty');
    return false;
  }

  input.classList.remove('error');
  input.classList.add('valid');
  return true;
};

export const handleKeyupEvent = (nameInputField, cardholderIdField) => {
  nameInputField.addEventListener('keyup', input => {
    if (input.currentTarget.value !== '') {
      input.currentTarget.classList.add('dirty');
      validateNameField(input.currentTarget);
    } else if (input.currentTarget.value === '') {
      input.currentTarget.classList.add('error', 'dirty');
    } else {
      input.currentTarget.classList.remove('valid', 'error', 'dirty');
    }
  });

  cardholderIdField.addEventListener('keyup', () => {
    cardholderIdActions.validateCardholderIdField();
  });
};

export const handleClickEvent = submitButton => {
  submitButton.addEventListener('click', () => {
    cardholderIdActions.validateCardholderIdField();
  });
};

export function appendPrimerTextToSubmitButton() {
  const submitButton = document.querySelector('#primer-checkout-submit-button');
  const primerText = document.createElement('span');
  primerText.textContent = backEndVars.primerPayBtnContent;
  primerText.id = 'primer-text-msg';
  submitButton.appendChild(primerText);
}

const primerButtonsOnlyStyles = () => {
  const primerCardForm = document.querySelector('#primer-checkout-card-form');
  if (!primerCardForm) {
    const buttonsContainer = document.querySelector('#primer-checkout-other-payment-methods');
    if (buttonsContainer) {
      buttonsContainer.style.paddingTop = '60px';
    }
  }
};

export function formatPaymentProviders() {
  primerButtonsOnlyStyles();
  const providersContainer = document.createElement('div');
  providersContainer.innerHTML = cardProvidersMarkup(backEndVars.tm120);
  const primerForm = document.querySelector('#primer-checkout-card-form');
  primerForm.insertAdjacentElement('beforebegin', providersContainer);
  providersContainer.querySelector('.card-providers-container').classList.remove('hidden');

  const checkoutBtns = document.querySelector('#primer-checkout-apm-button-container');
  if (checkoutBtns) {
    checkoutBtns.classList.add('mt-8');
  } else {
    const separator = document.querySelector('.or-separator');
    separator.classList.add('hidden');
  }
}

export async function updateClientSession(clientToken) {
  let data = {
    customerUuid: getCustomerUuid(),
    nationalDocumentId: document.querySelector('#primer-checkout-card-cardholder-id-input').value,
  };

  return fetcher.put(new Url().build('payments', 'payment-session', clientToken), data);
}
